
<div *ngFor='let data of domainAffilateData'>
 
    <object *ngIf="data.pdf64" [data]="transformpdf(data.pdf64)"></object>

</div>

